import type { ICampaign } from "../../../../types/models/campaign.models.types";
import { useGetHttp } from "../../http.hook";

interface IResponse {
  campaign: ICampaign;
}

export function useGetCampaignByIdEphemeralHttp() {
  return useGetHttp<IResponse>({
    path: "/ephemeral/brand-dash/campaigns",
  });
}
